export default __webpack_public_path__ + "images/105dffdbc07a20539fdaaf6278db5ac1.png";